export class TransporterModel {
  transporterId: number = 0;
  branchId: number = 0;
  typeDocumentId: number = 0;
  document: string = '';
  digitVerification: number = 0;
  name: string = '';
  phone: string = '';
  alterPhone: string | null = null;
  active: boolean = true;
  swExternal: boolean = false;
  providerId: number | null = null;
  userId: number | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
